// extracted by mini-css-extract-plugin
export default {"description-list":"DescriptionList_description-list__uE2L-","item-key":"DescriptionList_item-key__1Glfz","item-value":"DescriptionList_item-value__vDh6G"};